
type VideoAspectRatio = "16/9" | "9/16";

interface VideoPlayerProps {
    url: string;
    height?: number;
    /** When set, iframe fills an aspect-ratio box instead of a fixed height. */
    aspectRatio?: VideoAspectRatio;
}
VideoPlayer.defaultProps = {
    height: 600,
};
export function VideoPlayer({ url, height = 600, aspectRatio }: VideoPlayerProps) {
    // Function to check if the URL is a YouTube link
    function isYouTubeUrl(url: string) {
        const pattern = /^(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
        return pattern.test(url);
    };

    // Function to extract the YouTube ID from the URL
    function extractYouTubeId(url: string) {
        // Special handling for YouTube Shorts
        if (url.includes('/shorts/')) {
            const parts = url.split('/shorts/');
            if (parts[1]) {
            // Remove any query parameters after the video id
            const id = parts[1].split('?')[0];
            return id;
            }
        }
       
        // Fallback to standard URL extraction for regular YouTube URLs
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : null;
    };

    // Determine the correct src for the iframe
    function getIframeSrc() {
        if (isYouTubeUrl(url)) {
            const videoId = extractYouTubeId(url);
            return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
        }
        return url;
    };
  
    const iframeSrc = getIframeSrc();
    const iframeAllow =
        "accelerometer; autoplay *; clipboard-write; encrypted-media; gyroscope; picture-in-picture";

    if (aspectRatio) {
        const aspectClass =
            aspectRatio === "9/16" ? "aspect-[9/16]" : "aspect-video";

        return (
            <div className={`relative w-full overflow-hidden ${aspectClass}`}>
                <iframe
                    src={iframeSrc}
                    title="Video player"
                    className="absolute inset-0 h-full w-full border-0"
                    allow={iframeAllow}
                    allowFullScreen
                />
            </div>
        );
    }

    return (
        <iframe
            src={iframeSrc}
            width="100%"
            height={`${height}px`}
            className="z-40"
            allow={iframeAllow}
            allowFullScreen
        />
    );
};

interface PDFViewerProps {
    src: string;
};
export function PDFViewer({ src } : PDFViewerProps) {
    return (
        // <div className="w-screen h-screen">
        //     <embed src={src} type="application/pdf" width="100%" height="100%" />
        // </div>
        <div className="h-screen">
            <iframe className="w-full h-screen overflow-y-auto" src={src} width="100%" height="100%" />
        </div>
    );
};